if (!customElements.get('aham-load-more')) {
  customElements.define('aham-load-more', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.grid = this.closest('#ProductGridContainer')?.querySelector('ul.product-grid');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.error = this.querySelector('[role="alert"]');
      if (!this.grid || !this.button || !this.status || !this.error) return;
      this.initialized = true;
      this.button.addEventListener('click', () => this.loadMore());
      this.setAttribute('data-enhanced', '');
      this.status.hidden = false;
      this.updateStatus();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    updateStatus() {
      const shown = this.grid.querySelectorAll(':scope > .grid__item').length;
      this.status.textContent = this.dataset.countLabel
        .replace('[shown]', String(shown))
        .replace('[total]', this.dataset.total);
      this.button.hidden = !this.dataset.nextUrl;
    }

    async loadMore() {
      if (this.loading || !this.dataset.nextUrl || this.closest('.collection')?.classList.contains('loading')) return;
      this.loading = true;
      this.controller = new AbortController();
      this.button.disabled = true;
      this.button.textContent = this.dataset.loadingLabel;
      this.grid.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      this.removeAttribute('data-error');
      const initialLocation = window.location.href;
      try {
        const url = new URL(this.dataset.nextUrl, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Unexpected pagination origin');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Unable to load products');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = html.querySelector('#ProductGridContainer ul.product-grid');
        const nextControl = html.querySelector('aham-load-more');
        if (!nextGrid || !nextControl) throw new Error('Product grid missing');
        const nodes = Array.from(nextGrid.children).filter(item =>
          item.classList.contains('grid__item') || item.hasAttribute('data-size-divider')
        );
        const items = nodes.filter(item => item.classList.contains('grid__item'));
        if (!items.length || nextControl.dataset.nextUrl === this.dataset.nextUrl) throw new Error('Invalid next page');
        if (!this.isConnected || window.location.href !== initialLocation) return;
        const fragment = document.createDocumentFragment();
        let lastGroup = this.grid.querySelector(':scope > .grid__item:last-child')?.dataset.containerGroup;
        for (const item of nodes) {
          if (item.hasAttribute('data-size-divider')) {
            if (item.dataset.sizeDivider !== lastGroup) fragment.append(item);
            continue;
          }
          lastGroup = item.dataset.containerGroup;
          item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('.scroll-trigger').forEach(element => element.classList.add('scroll-trigger--cancel'));
          fragment.append(item);
        }
        this.grid.append(fragment);
        this.dataset.nextUrl = nextControl.dataset.nextUrl || '';
        this.querySelector('.aham-load-more__fallback').innerHTML = nextControl.querySelector('.aham-load-more__fallback').innerHTML;
        this.updateStatus();
        items[0].querySelector('a[href]')?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.error.textContent = this.dataset.errorLabel;
          this.error.hidden = false;
          this.setAttribute('data-error', '');
        }
      } finally {
        this.loading = false;
        this.button.disabled = false;
        this.button.textContent = this.dataset.buttonLabel;
        this.grid.removeAttribute('aria-busy');
      }
    }
  });
}

